import React from 'react';

// 無地の白背景（装飾なし）
const SiteBackground = () => (
  <div className="fixed inset-0 -z-10 bg-white" aria-hidden="true" />
);

export default SiteBackground;
